import { PortalError } from './PortalError';

export class TransitionError extends PortalError {
  constructor() {
    super('TransitionError', 'Transition was not updated correctly');
  }
}
